import {
  FETCH_INVENTORY,
  RESET_INVENTORY,
} from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
};

const inventoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_INVENTORY:
      return { list: action.payload, others: action.others };
    case RESET_INVENTORY:
      return initialState;
    default:
      return state;
  }
};

export default inventoryReducer;
